import React from "react";
import { X } from "lucide-react";
import { Button } from "../Button/Button.js";
import { cn } from "../../lib/utils.js";

/* ChipRemoveButton — the one remove (×) control of a chip. Internal: Chip
   renders it (so FilterChip does, through Chip), OwnerChip's remove control
   imports this same file, and it is NOT exported from the barrel.

   It is a design-system Button: ghost, iconOnly, xs, circle (OK-16, PR 3) —
   the 24px round hover wash and the one `focus-ring`, with today's 12px
   glyph. HIT_AREA keeps the chip's size: the -m-1 margin gives the 24px box
   the 16px layout box the old drawn control had, so no chip grows (Q3), and
   an invisible ::after still widens the target to 44x44px under a coarse
   pointer. A pseudo-element hit-tests as its button, so a press anywhere in
   it removes. */
export const HIT_AREA =
  "-m-1 relative after:absolute pointer-coarse:after:-inset-2.5";

/* A disabled chip's frame already dims the whole chip, so the × does not dim
   a second time (the same guard as the body's BODY_INK). */
export const NO_SECOND_DIM = "disabled:opacity-100";

export interface ChipRemoveButtonProps {
  /** Accessible name, e.g. "Remove Owner". */
  label: string;
  onRemove: () => void;
  disabled?: boolean | undefined;
}

export function ChipRemoveButton({
  label,
  onRemove,
  disabled,
}: ChipRemoveButtonProps): React.ReactElement {
  return (
    <Button
      variant="ghost"
      iconOnly
      size="xs"
      shape="circle"
      aria-label={label}
      onClick={onRemove}
      disabled={disabled}
      className={cn(HIT_AREA, NO_SECOND_DIM)}
    >
      <X className="h-3 w-3" aria-hidden />
    </Button>
  );
}
